import { TreeNode } from 'primeng/api';
import { StageTreeNode } from '@cosmos/shared';

/**
 * Stage subtrees → PrimeNG checkbox-tree nodes. Stages are containers only;
 * measurement leaves carry the thin `meta` used to derive variables before any
 * data is fetched (tree nodes hold no time-series data — Compare re-fetches by id).
 */
export function buildCompareTree(stages: StageTreeNode[]): TreeNode[] {
  return (stages ?? []).map((stage) => ({
    label: stage.name,
    data: { type: 'stage', id: stage._id },
    icon: 'fa-solid fa-folder',
    children: [
      ...buildCompareTree(stage.children),
      ...(stage.measurements ?? []).map((m) => ({
        label: m.name,
        data: {
          type: 'measurement',
          id: m._id,
          meta: { _id: m._id, name: m.name, measurementType: m.measurementType, dataChannels: m.dataChannels },
        },
        leaf: true,
        icon: 'fa-solid fa-chart-line',
      })),
    ],
  }));
}
